import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { AppDispatch } from '../store/store';
import { logout as logoutAction } from '../store/auth/authSlice';

const Logout: React.FC = () => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(logoutAction()).finally(() => {
      window.location.href = '/umsokn/login?loggedOut=true';
    });
  }, [dispatch]);

  return <>{t('loading')}</>;
};

export default Logout;
